<span
  >This is a dummy notification to demonstrate notification system. Click
  <a href="javascript:void(0)" (click)="onClick($event)">here</a> to see notification id.</span
>
